import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

/** Capture the invoice document element and download it as a PDF. */
export const downloadInvoicePdf = async (
  element: HTMLElement,
  fileName: string
) => {
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: '#ffffff',
    logging: false,
  })

  const imgData = canvas.toDataURL('image/png')
  const pdf = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
  })

  const pageWidth = pdf.internal.pageSize.getWidth()
  const pageHeight = pdf.internal.pageSize.getHeight()
  const margin = 10
  const contentWidth = pageWidth - margin * 2
  const contentHeight = (canvas.height * contentWidth) / canvas.width

  let heightLeft = contentHeight
  let position = margin

  pdf.addImage(imgData, 'PNG', margin, position, contentWidth, contentHeight)
  heightLeft -= pageHeight - margin * 2

  while (heightLeft > 0) {
    position = margin - (contentHeight - heightLeft)
    pdf.addPage()
    pdf.addImage(imgData, 'PNG', margin, position, contentWidth, contentHeight)
    heightLeft -= pageHeight - margin * 2
  }

  const safeName = fileName.replace(/[^a-zA-Z0-9._-]/g, '_')
  pdf.save(safeName.endsWith('.pdf') ? safeName : `${safeName}.pdf`)
}
